import React from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import { Leaf, ScommesseLeafItem } from 'components/scommesseTipo/components/cells';

import { ScommesseQuoteListItemProps } from 'components/scommesseTipo/components/scommesseQuoteList';
import classNames from 'classnames';
import styles from './ScommesseQuoteList.module.scss';
import { useIsAtLeastOneActive } from 'features/sport/hooks';

export const InfoAggiuntivaListItem = ({
  itemKey,
  disabled,
  isSelected,
  isBilanciata,
  scommessaKey,
  infoAggiuntivaKey,
  onClick,
}: ScommesseQuoteListItemProps) => {
  return (
    <button
      type="button"
      className={classNames(styles.btn, { [styles.active]: isSelected })}
      disabled={disabled}
      data-testid={`InfoAggiuntiva-ListItem-${itemKey}`}
      onClick={() => onClick(itemKey)}
    >
      <span className={classNames(styles.check)}>
        {isSelected && <Icon iconId={IconsEnum.CHECK} className={styles.checkIcon} color="var(--color-primary)" />}
      </span>
      <span className={classNames(styles.left, styles.highlighted, styles.flat, { [styles.balance]: isBilanciata })}>
        {
          <Leaf
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={infoAggiuntivaKey}
            itemKey={infoAggiuntivaKey}
            type={ScommesseLeafItem.InfoAggiuntiva}
          />
        }
      </span>
    </button>
  );
};